import React from 'react';

function HelloFaxGlyph(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} height="56" viewBox="0 0 106 106" fill="none" className={props.className}>
      <path d="M24.2117 24.2117V81.7884H81.7884V24.2117H24.2117ZM29.6581 29.6581H76.342V39.773H61.9866L39.773 61.9869V76.342H29.6581V29.6581ZM60.3916 49.0709V60.3916H49.0706L60.3916 49.0709ZM45.2194 76.342V65.8386H65.8381V45.2194H76.3415V76.342H45.2194Z" fill="#F3961F" />
    </svg>
  );
}

export default React.memo(HelloFaxGlyph);
